module.exports = __webpack_public_path__ + "img/google_chat_icon.32cd41bb.svg";